import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Modal from '~components/atoms/Modal';
import { TCreateNewProjectReduxParams } from '~types/feat/project';
import ProjectManagementCreateProjectForm from '../ProjectManagementCreateProjectForm';

const ProjectManagementCreateProjectModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.project.modals.createNewProjectModalIsOpen);
    const isLoading = useAppSelector(state => state.project.loadings.createNewProject);
    const error = useAppSelector(state => state.project.errors.createNewProject);

    const handleModalOnClose = () => {
        dispatch(combinedActions.projectResetCreateNewProjectState());
        dispatch(combinedActions.projectSetCreateNewProjectModalIsOpen(false));
    };

    const handleOnSubmit = (data: TCreateNewProjectReduxParams) => !isLoading && dispatch(combinedActions.projectCreateNewProjectAttempt(data));

    return (
        <Modal
            title='Create Project'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            <ProjectManagementCreateProjectForm
                submitButtonLabel='Create Project'
                onSubmit={handleOnSubmit}
                actionButtonIsLoading={isLoading}
                error={error}
            />
        </Modal>
    );
};

export default ProjectManagementCreateProjectModal;
